module.exports = __webpack_public_path__ + "static/media/ct3_5min-min.e726a8bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/create-tracks/florariums/ct3_5min-min.jpg
// module id = 272
// module chunks = 0